import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

const CustomerCardError = () => {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot Display Customers'}
    </Alert>
  );
};

export { CustomerCardError };
